import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "./Chatbot.css";
import {
  getAppSetup,
  getSocialMedia,
} from "../../../utils/apis/contact-us/ContactUs";
import { IDS } from "../../../utils/common";
import { Context } from "../../../utils/context";

const WhatsappChatbot = () => {
  const [appsetup, setAppSetup] = useState({});

  const getAppSetups = async () => {
    const res = await getAppSetup();

    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getAppSetups();
  }, []);

  return (
    <a
      href={`https://wa.me/${appsetup?.contact_no}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp_chatbot"
      aria-label="Chat with us on WhatsApp"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="whatsapp_icon" />
    </a>
  );
};

export default WhatsappChatbot;
